import { render, staticRenderFns } from "./gradient.vue?vue&type=template&id=007f2654&scoped=true"
import script from "./gradient.vue?vue&type=script&lang=js"
export * from "./gradient.vue?vue&type=script&lang=js"
import style0 from "./gradient.vue?vue&type=style&index=0&id=007f2654&prod&lang=scss&scoped=true"
import style1 from "./gradient.vue?vue&type=style&index=1&id=007f2654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f2654",
  null
  
)

export default component.exports